import mediaQueries from "./media-queries";
import editor from "./editor";

const previewWrapper = {
  ...editor.previewWrapper,
  marginTop: "15px"
};

const rightCol = {
  ...editor.rightCol,
  [mediaQueries.desktop]: {
    ...editor.rightCol[mediaQueries.desktop],
    marginTop: 0,
    width: "28%"
  }
};

const buttons = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  margin: 0
};

const button = {
  backgroundColor: "#BB9959",
  flexGrow: 0,
  flexShrink: 0,
  width: "calc(50% - 5px)",
  marginBottom: "0",
  cursor: "pointer",
  padding: "22px 25px 16px",
  "&:nth-last-child(4):first-child, &:nth-last-child(4):first-child ~ li": {
    [mediaQueries.dektop]: {
      marginBottom: "14px"
    }
  }
};

const buttonInverted = {
  ...button,
  backgroundColor: "#ffffff",
  color: "#BB9959",
  border: "2px solid #BB9959",
  paddingTop: "20px",
  paddingBottom: "14px",
  display: "flex",
  flexDirection: "column",
  paddingLeft: "0",
  paddingRight: "0"
};

const buttonTop = {
  width: "100%",
  height: "30px",
  marginBottom: "10px",
  textAlign: "center"
};

const buttonIcon = {
  maxHeight: "30px"
};

const buttonText = {
  width: "100%",
  textAlign: "center"
};

const buttonTitle = {
  fontFamily: "JWSansBold !important",
  fontSize: "14px",
  letterSpacing: "2.62px",
  lineHeight: "24px",
  textTransform: "uppercase",
  color: "#FFFFFF",
  display: "inline-block",
  margin: 0,
  borderBottom: "2px solid transparent",
  transition: "border-color 0.1s ease-in-out",
  textAlign: "center"
};

const buttonTitleInverted = {
  ...buttonTitle,
  color: "#BB9959"
}

export default {
  previewWrapper,
  rightCol,
  buttons,
  button,
  buttonInverted,
  buttonTop,
  buttonIcon,
  buttonText,
  buttonTitle,
  buttonTitleInverted
};



// WEBPACK FOOTER //
// ./src/styles/edit-main.js